module.exports = __webpack_public_path__ + "static/benefit-3-0e11e2fb736d2c2c78afea12faa97efb.svg";